import { render, staticRenderFns } from "./FundSplit.vue?vue&type=template&id=1f71bd01&scoped=true"
import script from "./FundSplit.vue?vue&type=script&lang=js"
export * from "./FundSplit.vue?vue&type=script&lang=js"
import style0 from "./FundSplit.vue?vue&type=style&index=0&id=1f71bd01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71bd01",
  null
  
)

export default component.exports